import React, {createContext, useContext, useEffect, useState} from "react";

const LANGUAGE_STORAGE_KEY = "appLanguage";
const LanguageContext = createContext();

export const getLocalizedRouteName = (route, language) => {
    if (language === "ne") {
        return route.nepaliName || route.name;
    }

    return route.englishName || route.name;
};

export const LanguageProvider = ({children}) => {
    const [language, setLanguage] = useState(
        () => localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en"
    );

    useEffect(() => {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        document.documentElement.lang = language;
    }, [language]);

    const toggleLanguage = () => {
        setLanguage((currentLanguage) => currentLanguage === "en" ? "ne" : "en");
    };

    return (
        <LanguageContext.Provider value={{language, toggleLanguage}}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
